import { render, staticRenderFns } from "./CustomerInvoicesDetails.vue?vue&type=template&id=07bb1f97&scoped=true&"
import script from "./CustomerInvoicesDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoicesDetails.vue?vue&type=style&index=0&id=07bb1f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb1f97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07bb1f97')) {
      api.createRecord('07bb1f97', component.options)
    } else {
      api.reload('07bb1f97', component.options)
    }
    module.hot.accept("./CustomerInvoicesDetails.vue?vue&type=template&id=07bb1f97&scoped=true&", function () {
      api.rerender('07bb1f97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/CustomerInvoicesDetails.vue"
export default component.exports